export const getCheckedState = (elementId: string): boolean => {
  const element = document.getElementById(elementId) as HTMLInputElement
  return element?.checked
}
